import { BaseDto } from "src/dtos/common/baseDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SalOrderHdrDto extends Omit<BaseDto, 'insertDt' | 'updateDt'> {
	salesOrderNo: string;		// 주문번호
	compCd: string;				// 회사코드
	orderDt: string | undefined;	// 주문일자 (YYYY-MM-DD)

	customCd: string;			// 거래처코드
	moneyCd: string;			// 통화코드
	vatType: string;			// 과세유형
	logicCenter: string;		// 기본물류
	warehouseCd: string;		// 창고코드
	warehouseNm: string;		// 창고명

	orderAmt: number;			// 주문금액
	vatAmt: number;				// 부가세
	totBaseVat: string;			// 공급총액기준 부가세 YN
	totalAmt: number;			// 합계금액

	dueDt: string | undefined;	// 납기일 (YYYY-MM-DD)
	telNo: string;				// 전화번호
	faxNo: string;				// 팩스번호
	email: string;				// 이메일
	post: string;				// 우편번호
	address: string;			// 주소
	detailAddress: string;		// 상세주소

	compNm: string;				// 사업장명
	empNm: string;				// 사원명
	customNm: string;			// 거래처명

	empNo: string;				// 담당자
	approveFlg: string;			// 승인여부
	orderStatus: string;		// 주문상태
	remark: string;				// 비고

	insertDt: string;			// 등록일시 (ISO datetime string)
	insertUser: string;			// 등록자
	insertForm: string;			// 등록폼

	updateDt: string;			// 수정일시 (ISO datetime string)
	updateUser: string;			// 수정자
	updateForm: string;			// 수정폼

	inserted: boolean;
	isModified: boolean;
}

export const defaultSalOrderHdrDto: SalOrderHdrDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salesOrderNo: '',
	compCd: '',
	orderDt: formatDate(new Date()),
	customCd: '',
	moneyCd: '',
	vatType: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totBaseVat: 'N',
	totalAmt: 0,
	dueDt: formatDate(new Date()),
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	detailAddress: '',
	empNo: '',
	approveFlg: 'N',
	orderStatus: '',
	remark: '',

	insertDt: new Date().toISOString(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date().toISOString(),
	updateUser: '',
	updateForm: '',

	compNm: '',
	empNm: '',
	customNm: '',

	inserted: false,
	isModified: false,
};

export interface SalOrderDtlDto extends Omit<BaseDto, 'insertDt' | 'updateDt'> {
	salesOrderNo: string;		// 주문번호
	itemNo: string;				// 아이템 일련번호
	compCd: string;				// 회사코드

	logicCenter: string;		// 물류센터
	orderDt: string | undefined;	// 주문일자 (YYYY-MM-DD)
	customCd: string;			// 거래처코드
	customNm: string;			// 거래처명
	itemSeq: number;			// 품목순번
	itemCd: string;				// 품목코드

	orderUnit: string;          // 주문단위
	orderQty: number;           // 수량
	cancelQty: number;           // 취소수량
	orderPrice: number;         // 단가
	dcAmt: number;              // 할인액
	itemAmt: number;            // 품목금액
	itemNm: string;				// 품목명
	itemSpec: string;			// 규격
	itemUnit: string;			// 단위

	remark: string;				// 비고

	insertDt: string | undefined;	// 등록일시 (ISO datetime string)
	insertUser: string;			// 등록자
	insertForm: string;			// 등록폼

	updateDt: string | undefined;	// 수정일시 (ISO datetime string)
	updateUser: string;			// 수정자
	updateForm: string;			// 수정폼

	inserted: boolean;
	isModified: boolean;
}

export const defaultSalOrderDtlDto: SalOrderDtlDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salesOrderNo: '',
	itemNo: '',
	compCd: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 0,
	itemCd: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	orderPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	remark: '',
	insertDt: new Date().toISOString(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date().toISOString(),
	updateUser: '',
	updateForm: '',

	itemNm: '',
	itemSpec: '',
	itemUnit: '',

	inserted: false,
	isModified: false,
};
